import React from 'react';
import Header from './Header';
import Plazma from './Plazma';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css'; 

const Main = (props) => { 
    const { appointment, title, blocking, logo, className } = props;

    return (
        <BlockUi tag="div" blocking={blocking}>
            <div className={className ? `main ${className}` : "main"}>
                <Header doctorName={appointment.doctorName} cooperation={appointment.cooperation} logo={logo} />
                <Plazma title={title} />
                {props.children}
            </div>
        </BlockUi>
    );
}

export default Main;